import {doc, runTransaction} from "firebase/firestore";
import {fire} from "../../../fire";

export const actualizarIventarioVariosIds = async ({arrProductos, col}) => {


    for (let i = 0; i < arrProductos.length; i++) {
        let producto = arrProductos[i]
        await actualizarProducto(col, producto)
    }


}

const actualizarProducto = async (col, producto) => {

    let sfDocRef = doc(fire, col, producto.id);

    let dox = await runTransaction(fire, async (transaction) => {
        const sfDoc = await transaction.get(sfDocRef);
        if (sfDoc.exists()) {
            let variaciones = sfDoc.data().variaciones;
            let index = variaciones.findIndex((e) => e.nombre === producto.presentacion)
            let variacionIndicada = variaciones[index]

            variacionIndicada.cantidad = parseInt(variacionIndicada.cantidad) - parseInt(producto.cantidad)

            variaciones[index] = variacionIndicada
            transaction.update(sfDocRef, {variaciones: variaciones})
        }
    });

    return dox


}